export default "__VITE_ASSET__XXLJiILQ__"